import DailyReservationGroup from '@/model/reservation/DailyReservationGroup'
import Moment from 'moment'

export default class DailyReservation {
  private constructor (
    readonly date: string,
    readonly groupList: DailyReservationGroup[],

  ) {}

  static createFromResponse (responseData: any, filterDate: string): DailyReservation {

    let reservationByGroup:any[] = []
    let reservations:any[] = []
    let lastgroupId:number = 0
    responseData.forEach( (item:any) => {

      if( lastgroupId !== item.boarderGroup.id)
      {

        if( reservationByGroup.length > 0)
          reservations.push(reservationByGroup)

        reservationByGroup = []
      }

      reservationByGroup.push(item)

      lastgroupId = item.boarderGroup.id

    })

    if( reservationByGroup.length > 0)
      reservations.push(reservationByGroup)

    const date = Moment(filterDate).format("DD.MM.Y");

    return new DailyReservation(
      date,
      reservations.map( (item:any):DailyReservationGroup => DailyReservationGroup.createFromResponse(item))
     )

  }
}
